import { captureException, captureMessage } from "@sentry/nextjs";

const logger = {};

logger.log = function (message) {
    captureMessage(message);
    console.log(message);
    return message;
}

logger.error = function (error) {
    captureException(error);

    return error.message || error;
}

export default logger;